import VirtualClassL from "../../Components/VirtualClassL/VirtualClassL";
import "./Lecturer.css"
import { Link, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import img1 from "../../Images/UnilusLogo.PNG"
import img2 from "../../Images/UnilusLogo3.png"
import img3 from "../../Images/ActivityGen2.png"
import { faChalkboardTeacher,faBookReader,faDiagnoses,faUsers, faAtlas,faArrowDownAZ, faChevronDown,faBars,faTimes } from '@fortawesome/free-solid-svg-icons'
import { useState,useEffect } from "react";


function Lecturer() {

     const [navDrop, setNavDrop] = useState(false)
     const [pickDrop, setPickdrop] = useState(false)
     const [mode, setMode] = useState(["Lecturer","Student"])
     const [selected, setSelected] = useState("Student")
     let listener = null
     const [scrollState, setScrollState] = useState(false)

    //  const [selectMode, setSelectMode] = useState(["Lecturer","Student"])

     const handleDrop = () =>{

      setNavDrop(!navDrop)
          
     }
     const handlePickerDrop = () =>{

        setPickdrop(!pickDrop)
        // console.log("here is pickdrop",pickDrop)
          
     }
     const handleSelect = (item) =>{

    
        // console.log("here is pickdrop2",item)
          
     }
   

     //Changes NavBar color when you scroll over 120 pixels

     useEffect(() => {
      listener = document.addEventListener("scroll", e => {
        var scrolled = document.scrollingElement.scrollTop
        if (scrolled >= 120) {
          if (scrollState !== true) setScrollState(true)
        } else {
          if (scrollState !== false) setScrollState(false)
        }
      })
      return () => {
        document.removeEventListener("scroll", listener)
      }
    }, [scrollState])




    return (
      <div className="lecturerCover">

           {/* <div className="TopBanner">

                  <div className="modeToggle"> 
                                              { 
                                                  pickDrop && mode.map((Item,index)=>{

                                                      return(
                                                        <div 

                                                        onClick={(e)=>{
                                                          setSelected(Item)
                                                          setPickdrop(false)
                                                          // console.log("HIII there",Item)

                                                        }}
                                                        
                                                        
                                                        key={index} className="modeItem">

                                                               <h3 >{Item}</h3>

                                                          </div>
                                                      )

                                                  })

                                              }

                  </div>

           <div className="Logo"><img src={img1}></img></div>
              <div className="Dropdown" onClick={handlePickerDrop}>
            
                <button>
                  <h2>{selected}</h2><FontAwesomeIcon className="FontAwesomeIcon2"  icon={faChevronDown} />
                      
                          
                </button>
                           
              
              </div>
            
           </div> */}

           {/* End of top banner Nav */}

           <div className={scrollState? "scrollCover": "NavCover"}>

           
           <div className="TopBanner">

                  <div className="modeToggle"> 
                                              { 
                                                  pickDrop && mode.map((Item,index)=>{

                                                      return(
                                                        <div 

                                                        onClick={(e)=>{
                                                          setSelected(Item)
                                                          setPickdrop(false)
                                                          // console.log("HIII there",Item)

                                                        }}
                                                        
                                                        
                                                        key={index} className="modeItem">

                                                               <h3 >{Item}</h3>

                                                          </div>
                                                      )

                                                  })

                                              }

                  </div>
          
           <Link to={"https://www.unilus.ac.zm"}>
           <div className="Logo"><img src={img1}></img></div>
           </Link>
              <div className="Dropdown" onClick={handlePickerDrop}>
            
                <button>
                  <h2>{selected}</h2><FontAwesomeIcon className="FontAwesomeIcon2"  icon={faChevronDown} />
                      
                          
                </button>
                           
              
              </div>
            
           </div>

           </div>

           {/* End of top banner Nav */}

           <div className="TopBannerRes">
           <Link to={"https://www.unilus.ac.zm"}>
                <div className="Logo">

                      <img src={img2}></img>
                      {/* <FontAwesomeIcon className="FontAwesomeIcon3"  icon={faBars} /> */}
                    
                
                </div>
              </Link>
              <div className="toggleIcon" onClick={handleDrop}>
                    {navDrop? 

                            <FontAwesomeIcon className="FontAwesomeIcon3"  icon={faTimes} /> :
                            <FontAwesomeIcon className="FontAwesomeIcon3"  icon={faBars} />

                    }
           
              </div>
              
        
                
                
            
           </div>
           <>
            {
              navDrop && 
                  
                      <div className="dropContent"> 

                            <div className="dropList"> 
                                
                                <ul>
                                      <li><Link className="listItem" to={"/"}>Virtual Class</Link></li>
                                        <li><Link className="listItem" to={"/AsgmntL"}>Assignments</Link></li>
                                        <li><Link className="listItem" to={"/Quizzes"}>Quizzes</Link></li>
                                        <li><Link className="listItem" to={"/Users"}>Users</Link></li>
                                        {/* <li><Link className="listItem" to={"/Resources"}>Resources</Link></li> */}
                                        
                                </ul>

                            </div>

                    </div>

             }          
       
       </>
      

           
           <div className="DisplayMode">
            <div className="Left">  

            {(selected == "Lecturer") && 

                <ul> 
                    <li><Link className="listItem" to={"/"}><FontAwesomeIcon className="FontAwesomeIcon" icon={faChalkboardTeacher} />Virtual Class</Link></li>
                    <li><Link className="listItem" to={"/AsgmntL"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faBookReader} />Assignments</Link></li>
                    <li><Link className="listItem" to={"/Quizzes"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faDiagnoses} />Quizzes</Link></li>
                    <li><Link className="listItem" to={"/Users"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faUsers} />Users</Link></li>
                    <li><Link className="listItem" to={"/Resources"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faAtlas} />Resources</Link></li>

                </ul>
                            
            }
            {(selected == "Student") && 

                <ul> 
                    <li><Link className="listItem" to={"/VirtualClassS"}><FontAwesomeIcon className="FontAwesomeIcon" icon={faChalkboardTeacher} />Virtual Class</Link></li>
                    <li><Link className="listItem" to={"/AsgmntS"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faBookReader} />Assignments</Link></li>
                    <li><Link className="listItem" to={"/QuizzesS"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faDiagnoses} />Quizzes</Link></li>
                    {/* <li><Link className="listItem" to={"/Users"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faUsers} />Users</Link></li> */}
                    <li><Link className="listItem" to={"/ResourcesS"}><FontAwesomeIcon className="FontAwesomeIcon"  icon={faAtlas} />Materials</Link></li>

                </ul>
                            
            }

              

            </div>
            <div className="Right"> 
    




                        <Outlet>
                            {/* <VirtualClassL/> */}
                        </Outlet>

            </div>
  
              
  
           </div>
      </div>
    );
  }
  
  export default Lecturer;
  